/**
 * Maps testType enum value to locale key format
 * Locale keys in JSON files are "FOB" and "HPylori" (not "fob" or "hpylori")
 */
export const getTestTypeLocaleKey = (testType: string | null | undefined): string => {
  if (!testType) return "HPylori"; // Default to HPylori
  
  const lowerTestType = testType.toLowerCase();
  
  if (lowerTestType === "fob") {
    return "FOB";
  }
  
  if (lowerTestType === "hpylori") {
    return "HPylori";
  }
  
  return testType;
};

